import { STORE_MODAL_TRADE } from '@app/constants/LOCALKEYS';
import useSWR from 'swr';
import { getPersistData } from '../persist';

const KEY = STORE_MODAL_TRADE;

let swrData: any = getPersistData(KEY);

export function useTradeModalStore(initData?: any, reset?: boolean) {
  const { data, mutate } = useSWR<any>(KEY, async () => {
    if (reset === true) {
      swrData = { showpos: true };
      return swrData;
    }

    if (initData !== undefined) {
      swrData = {
        ...initData,
        showpos: initData.showpos !== undefined ? initData.showpos : true,
      };
    } else if (!swrData) {
      swrData = { showpos: true };
    }

    return swrData;
  });

  return {
    data,
    mutate: (value: any) => {
      swrData = {
        ...value,
        showpos: value.showpos !== undefined ? value.showpos : swrData?.showpos ?? true,
      };
      return mutate();
    },
  };
}
